export const capitalize = (s: string): string => {
    // if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

export const notLocalOrDevEnv = () : boolean => {
    return process.env.REACT_APP_ENV_NAME !== 'DEV' && process.env.REACT_APP_ENV_NAME !== 'LOCAL';
}